import React from 'react';

import styles from './index.module.scss';

import joey_url from '../../assets/images/toys_joey.png';
import chandler_url from '../../assets/images/toys_chandler.png';
import ross_url from '../../assets/images/toys_ross.png';
import monica_url from '../../assets/images/toys_monica.png';
import rachel_url from '../../assets/images/toys_rachel.png';
import phoebe_url from '../../assets/images/toys_phoebe.png';

interface ToysProps {
  size?: 'small' | 'default';
}

const Toys: React.FC<ToysProps> = ({ size = 'default' }) => {
  return (
    <div className={`${styles.Toys} ${size === 'small' ? styles.Small : ''}`}>
      <img src={chandler_url} alt="Friends - Chandler" />
      <img src={ross_url} alt="Friends - Ross" />
      <img src={monica_url} alt="Friends - Monica" />
      <img src={phoebe_url} alt="Friends - Phoebe" />
      <img src={joey_url} alt="Friends - Joey" />
      <img src={rachel_url} alt="Friends - Rachel" />
    </div>
  );
};

export default Toys; 